import React from 'react';
import { painPoints } from '../data/salesContent';
export function Agitation() {
  return <section className="bg-bone px-5 py-14 sm:px-8" data-id="element-13" data-mp="3laj7k8r5wmo8">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-14" data-mp="3la15uwlqdg8x">
        <div data-id="element-15" data-mp="344o5ua4jkig">
          <h2 className="font-display text-[24px] font-bold leading-tight text-plum sm:text-[32px]" data-id="element-16" data-mp="32k10pq533um">
            ¿Tu cuerpo lleva meses gritándote y nadie entiende por qué?
          </h2>
          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-neutral-700 sm:text-[16px]" data-id="element-17" data-mp="37j4cv4nw6x1c">
            Te despiertas con el cuello rígido, la gastritis no te da tregua y los análisis dicen
            que estás bien. No es tu imaginación. Es tu sistema nervioso colapsando bajo emociones
            no procesadas. La buena noticia: puedes resetearlo en 7 minutos al día.
          </p>
        </div>

        <div data-id="element-18" data-mp="2nsslpl37xnkz">
          <h3 className="text-center font-display text-[18px] font-normal italic tracking-wide text-plum sm:text-[22px]" data-id="element-19" data-mp="2jta2quuyjmks">
            ¿Reconoces alguno de estos?
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-20" data-mp="37p0s46ns3aiz">
            {painPoints.map(item => <li key={item} className="flex items-start gap-3 rounded-lg border border-plum/15 bg-white px-4 py-3 shadow-[0_8px_20px_-18px_rgba(45,27,78,0.55)]" data-id="element-21" data-mp="3cnc16f691h05">
                <span aria-hidden="true" className="mt-0.5 text-[13px] font-black text-red-600" data-id="element-22" data-mp="3mdx76no95nt3">
                  ✗
                </span>
                <span className="text-[14px] leading-snug text-neutral-800 sm:text-[15px]" data-id="element-23" data-mp="2orq27co1dtg7">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-5 text-center text-[14px] font-bold text-emerald-deep" data-id="element-24" data-mp="2yo2ty500tx8b">
            Si marcaste 2 o más, este manual es para ti.
          </p>
        </div>
      </div>
    </section>;
}